import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Flex,
  ModalFooter, ModalHeader, ModalCloseButton, useStyleConfig, Text,
} from '@chakra-ui/react';
import { ModalStyle as styleRaw } from '../../../Modal/ModalStyle';
import ClearableNote from './ClearableNote';
import React from 'react';

const NotesModal = ({props,notesUtils}) => {
  const style = styleRaw.variants.jobIndustry;
  const stateProps = props.stateProps;
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
   const preventBlur=(e)=> {
    e.preventDefault();
  }
  return (
    <Modal
      sx={style.modal}
      isCentered
      isOpen={stateProps.isNotesModalOpen}
      onClose={stateProps.onNotesModalClose}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent style={style.modalContent} >
        <ModalHeader>Counselor Notes</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {notesUtils.notes !== undefined && (
          Object.values(notesUtils.notes).map((note,noteOrder) => {
              return (
                <ClearableNote note={note} noteOrder={noteOrder} notesUtils={notesUtils} />
              );
            },
          )
        )
        }
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
/*

        <ModalFooter>
          <Flex style={style.modalFooter}>
            <Button
              sx={{...buttonStyles.primary}}
              onClick={stateProps.onJobIndustryClose}
            >Choose</Button>
          </Flex>
        </ModalFooter>
 */
export default NotesModal;
